import React from "react";
import S from "../../../../assets/stylesheets/experience/sections/ExperienceItinerary.module.css";

/** 로고에서 텍스트 제거 — 아이콘 부분만 (viewBox 0 0 100 100) */
function FarmcitiIcon({ size = 48 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M96.0587 28.3214H3.33117C1.49142 28.3214 0 29.8128 0 31.6526V31.6552C0 33.4949 1.49142 34.9863 3.33117 34.9863H96.0587C97.8985 34.9863 99.3899 33.4949 99.3899 31.6552V31.6526C99.3899 29.8128 97.8985 28.3214 96.0587 28.3214Z" fill="#FCB826" />
      <path d="M78.2787 24.9234C76.3623 10.8475 64.298 0 49.6949 0C35.0917 0 23.0275 10.8475 21.1111 24.9234H78.2761H78.2787Z" fill="#FCB826" />
      <path d="M38.7419 36.7793C37.8879 36.7793 37.1033 37.2217 36.4911 37.9574C37.0544 38.279 37.4377 38.886 37.4377 39.5831C37.4377 40.6172 36.5991 41.4558 35.5651 41.4558C35.4416 41.4558 35.3181 41.4429 35.2024 41.4198C35.1869 41.6179 35.1766 41.8159 35.1766 42.0191C35.1766 44.913 36.7741 47.259 38.7445 47.259C40.7149 47.259 42.3123 44.913 42.3123 42.0191C42.3123 39.1253 40.7149 36.7793 38.7445 36.7793H38.7419Z" fill="#008B09" />
      <path d="M60.6479 36.7793C59.8325 36.7793 59.0839 37.1857 58.482 37.8623C59.1482 38.1504 59.6138 38.8114 59.6138 39.5831C59.6138 40.6172 58.7752 41.4558 57.7412 41.4558C57.5199 41.4558 57.309 41.4146 57.1135 41.3452C57.0929 41.5664 57.0801 41.7902 57.0801 42.0191C57.0801 44.913 58.6775 47.259 60.6479 47.259C62.6183 47.259 64.2157 44.913 64.2157 42.0191C64.2157 39.1253 62.6183 36.7793 60.6479 36.7793Z" fill="#008B09" />
      <path d="M10.4797 87.5803C24.5221 98.9681 51.7683 94.8163 51.7683 94.8163C51.7683 94.8163 52.2853 69.5971 38.2429 58.212C24.2006 46.8217 0.913219 52.2699 0.913219 52.2699C0.913219 52.2699 -3.56264 76.1926 10.4797 87.5803Z" fill="#008B09" />
      <path d="M88.9102 87.9199C74.8678 99.3076 47.6191 95.3256 47.6191 95.3256C47.6191 95.3256 47.1046 69.9367 61.147 58.5515C75.1894 47.1638 98.4767 52.612 98.4767 52.612C98.4767 52.612 102.953 76.5347 88.9102 87.9224V87.9199Z" fill="#FF7A34" />
      <path d="M57.0828 87.4748C57.0082 87.4748 56.931 87.4594 56.859 87.4233C56.6043 87.2999 56.4963 86.9912 56.6197 86.7365C58.1503 83.5726 67.1509 71.6961 78.3585 63.6936C78.59 63.5289 78.9116 63.5829 79.0762 63.8145C79.2408 64.046 79.1868 64.3675 78.9553 64.5321C68.419 72.0562 59.1741 83.8221 57.5458 87.1867C57.4557 87.3693 57.2731 87.4774 57.0828 87.4774V87.4748Z" fill="white" />
      <path d="M42.6853 87.4748C42.4435 87.4748 42.23 87.305 42.1811 87.0581C41.9265 85.7462 31.8712 72.4241 20.8127 64.5296C20.5812 64.3649 20.5272 64.0434 20.6918 63.8119C20.8565 63.5804 21.178 63.5264 21.4095 63.691C31.9844 71.2408 42.7908 84.8176 43.1895 86.86C43.2435 87.1378 43.0609 87.4079 42.7831 87.4645C42.7496 87.4722 42.7162 87.4748 42.6853 87.4748Z" fill="white" />
    </svg>
  );
}

export default function ExperienceItinerary({ itinerary }) {
  if (!itinerary || itinerary.length === 0) return null;

  return (
    <div className={S["exp-itinerary-section"]}>
      <h2 className={S["exp-section-title"]}>What you'll do</h2>

      <div className={S["itinerary-list"]}>
        {itinerary.map((item, idx) => {
          const imgUrl = item.image?.viewUrl || item.imageUrl || null;
          const isLast = idx === itinerary.length - 1;
          return (
            <div key={item.id || idx} className={S["itinerary-item"]}>
              <div className={S["itinerary-left"]}>
                <div className={S["itinerary-img-wrap"]}>
                  {imgUrl ? (
                    <img
                      src={imgUrl}
                      alt={item.title || item.stepTitle || ""}
                      className={S["itinerary-img"]}
                    />
                  ) : (
                    <div className={S["itinerary-img-placeholder"]}>
                      <FarmcitiIcon size={44} />
                    </div>
                  )}
                </div>
                {!isLast && <div className={S["itinerary-line"]} />}
              </div>

              <div className={S["itinerary-content"]}>
                <p className={S["itinerary-item-title"]}>
                  {item.title || item.stepTitle}
                </p>
                {(item.description || item.stepDescription) && (
                  <p className={S["itinerary-item-desc"]}>
                    {item.description || item.stepDescription}
                  </p>
                )}
                {item.duration && (
                  <span className={S["itinerary-item-duration"]}>
                    {item.duration}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
